import { createSelector } from 'reselect';
import { List, Map } from 'immutable';
import { getTabId } from 'src/utils/utils';

export const getIntegrationState = (state) => ({
  state: state.integration,
  getIn: (keyPath, defaultValue = null) => {
    const clientId = state.authentication.getIn(['tabs', getTabId(), 'clientId']);
    if (clientId && state.integration) {
      return state.integration.getIn([keyPath[0], clientId, ...keyPath.slice(1)], defaultValue);
    }
    return defaultValue;
  }
});
export const getIntegrations = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['integrations', 'data']) || List();
  }
);

export const getLoadingIntegrations = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['integrations', 'loading']) || false;
  }
);

export const getIntegrationFields = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['fields', 'data']) || List();
  }
);

export const getLoadingIntegrationFields = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['fields', 'loading']) || false;
  }
);

export const getLogsByFrogClient = frogId => createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'requestLogs', frogId], Map());
  }
);

export const getLoadingRequestLogs =  createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'requestLogs', 'loading'], false);
  }
);


export const getLoadingFetchLogs = createSelector(
  [getIntegrationState],
  (rule) => {
    return rule.getIn(['logs', 'fetchLogs', 'loading'], false);
  }
);
